module.exports = __webpack_public_path__ + "static/img/no_data_img.eac5f539.png";